<template>
  <sModal
    v-if="show"
    v-model="dialog"
    :title="title"
    @close="close">
    <sButton
      slot="activator"
      class="py-1 px-2 h11-links"
      data-qa="cancel-bid-btn"
      icon="cancel"
      @click="dialog = true">
      {{ $t('Tenders.Cancel') }}
    </sButton>
    <div style="color: var(--text-color)">
      <template
        v-if="external">
        {{ $t('Tenders.CanceledExternalOffersWillInHistory') }}
      </template>
      <div
        v-else
        class="flex">
        <sForm
          ref="canceBidForm"
          class="width-70"
          :disabled="loading"
          label-position="top"
          label-width="0px"
          :model="{text}"
          :rules="rules">
          <sFormItem
            class="mb-0"
            prop="text">
            <sInput
              class="mb-2"
              data-qa="cancel-bid-reason-textarea"
              max-length="4000"
              max-rows="15"
              rows="5"
              show-word-limit
              type="textarea"
              :value.sync="text"/>
          </sFormItem>
        </sForm>
        <div>
          <sAlert class="ml-3 mb-0">
            {{ $tc('Tenders.ReasonWillBeSentParticipant', participants_names.length) }}
            <template slot="desc">
              <span class="h7-text"> {{ $tc('Tenders.AannulledOfferWillMoveToHistory', participants_names.length) }} </span>
            </template>
          </sAlert>
        </div>
      </div>
    </div>
    <div
      key="footer"
      slot="footer">
      <sButton
        data-qa="cancel-bid-btn"
        @click="apply">
        {{ $t('Tenders.Cancel') }}
      </sButton>
      <sButton
        class="ml-2 h10-links black--text"
        data-qa="btn-dialog-template-second"
        :disabled="loading"
        type="text"
        @click="close">
        {{ $t('Common.Cancel') }}
      </sButton>
    </div>
  </sModal>
</template>

<script>
import { modalMixin, validateRuls } from 'mixins'
import SmarttenderApi from '@/api/smarttenderApi'
const st_api = new SmarttenderApi()

export default {
  name: 'annulBidDialog',
  mixins: [ modalMixin, validateRuls ],
  data() {
    return {
      show: true,
      dialog: false,
      text: '',
      loading: false,

      rules: {
        text: [
          {
            type: 'string',
            trigger: 'change',
            max: 4000,
            message: this.$t('Validate.maxLength', {number: 4000, type: this.$tc('Common.characters', 4000) })
          }
        ],
      }
    }
  },
  props: {
    tender: Object,
    bids: Array,
    external: Boolean
  },
  mounted() {
    this.rules.text.push(this.commentValidateRule[0])
    this.show = this.$acl.check('isGoodMode') || !this.$acl.get.includes('tenders_view')
  },
  computed: {
    title() {
      if (this.external) {
        return this.$t('Tenders.ReallyWantCancelOffersForSelectedLots')
      }
      if (this.participants_names.length > 1) {
        return  this.$t('Tenders.WhyCancelOffers', {participants: this.participants_names.join(', ')})
      }
      return this.$t('Tenders.WhyCancelOffer', {participant: this.participants_names[0] })
    },
    participants() {
      return  this.$_.groupBy(this.bids, 'bidderInfo.organizationName') || {}
    },
    participants_names() {
      return Object.keys(this.participants) || []
    },
  },
  methods: {
    open() {
      setTimeout(() => {
        this.dialog = true
      }, 100)
    },
    async apply() {
      if (!this.external) {
        await this.$refs.canceBidForm.validate()
      } else {
        const index = this.tender.bids.findIndex(i => i.bidDetails[0].idBidRow === this.bids[0].idBidRow)
        if (index && index !== -1) {
          this.tender.bids.splice(index, 1)
        }
      }
      this.loading = true
      let promises = Object.values(this.participants).map(async (bids) => {
        return await st_api.bidCancellation({
          tenderId: this.tender.tenderId,
          calncellationReasone: this.text,
          bidDetailIds: bids.map(el => el.id)
        })
          .then(res => {
            if (!res) {
              throw 'error'
            }
            bids.forEach(item => item.bidStatus = 'CANCELED_BY_ORGANIZER')
          })
      })
      await Promise.allSettled(promises).then(() => {
        this.text = ''
        this.$emit('callback')
        this.close()
      })
        .finally(() => {
          this.loading = false
        })
        .catch(error => {
          this.$log_error(error.message)
        })
    },
    close() {
      this.dialog = false
    }
  },
}
</script>

<style lang="scss">
.annul-bid-dialog {
  .info-block {
    max-width: 175px;
  }
}
</style>
